<template>
  <div :class="[$style.base, { [$style.isSmall]: $screen === 's' }]">
    <MergeCustomer
      v-if="showMergeModal"
      @updateCustomer="refetch"
      @close="showMergeModal = false"
    />
    <DeletedOverlay v-if="customer?.state === 'DELETED'" />
    <SafeTeleport
      v-else-if="!showMobileMenu && customer"
      to="#header-teleport"
    >
      <Flex
        align="center"
        v-test="'customer-header'"
      >
        <Flex
          align="center"
          :gap="0.5"
        >
          <BaseAvatar
            v-if="$screen !== 's'"
            size="l"
            :picture="customer.picture"
            :name="customer.fullName"
          />
          <div :class="$style.name">{{ customer.fullName }}</div>
        </Flex>
        <CustomerActions @merge="showMergeModal = true" />
      </Flex>
    </SafeTeleport>
    <div :class="$style.content">
      <BaseSpinner v-if="!customer" />
      <router-view
        v-else
        @updated="refetch"
      />
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'Customer',
};
</script>

<script
  lang="ts"
  setup
>
import { useQuery } from '@vue/apollo-composable';
import { storeToRefs } from 'pinia';
import { computed, provide, ref } from 'vue';
import { useRoute } from 'vue-router';
import { usePageLayoutStore } from '@/stores/page-layout';
import CustomerActions from './CustomerActions.vue';
import DeletedOverlay from './DeletedOverlay.vue';
import { GET_CUSTOMER } from './graphql';
import MergeCustomer from './MergeCustomer.vue';

const { showMobileMenu } = storeToRefs(usePageLayoutStore());

const route = useRoute();
const customerId = computed(() =>
  route && typeof route.params.customerId === 'string'
    ? parseInt(route.params.customerId)
    : null,
);

const { onResult, refetch } = useQuery(GET_CUSTOMER, () => ({
  id: customerId.value,
}));
const customer = ref(null);
onResult(({ data }) => {
  customer.value = data.customer;
});
provide('customer', customer);

const showMergeModal = ref(false);
</script>

<style
  lang="scss"
  module
>
.base {
  height: 100%;
  min-height: 100%;
}

.content {
  height: 100%;
}

.name {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
